module.exports = __webpack_public_path__ + "img/EVENT_AREA-CLIENTI_960x256-2-2-2.20487b04.jpg";